/*!
 * ==========================================================
 *  COLOR PICKER PLUGIN 1.3.5
 * ==========================================================
 * Author: Taufik Nurrohman <https://github.com/tovic>
 * License: MIT
 * ----------------------------------------------------------
 */
/* eslint-disable */
!(function (t, n, e) {
	function r(t) {
		return void 0 !== t;
	}
	function o(t) {
		return 'string' == typeof t;
	}
	function i(t) {
		return 'object' == typeof t;
	}
	function u(t) {
		return Object.keys(t).length;
	}
	function c(t, n, e) {
		return n > t ? n : t > e ? e : t;
	}
	function s(t, n) {
		return parseInt(t, n || 10);
	}
	function a(t) {
		return Math.round(t);
	}
	function f(t) {
		var n,
			e,
			r,
			o,
			i,
			u,
			c,
			s,
			f = +t[0],
			l = +t[1],
			h = +t[2];
		switch (
			((o = Math.floor(6 * f)),
			(i = 6 * f - o),
			(u = h * (1 - l)),
			(c = h * (1 - i * l)),
			(s = h * (1 - (1 - i) * l)),
			(o = o || 0),
			(c = c || 0),
			(s = s || 0),
			o % 6)
		) {
			case 0:
				((n = h), (e = s), (r = u));
				break;
			case 1:
				((n = c), (e = h), (r = u));
				break;
			case 2:
				((n = u), (e = h), (r = s));
				break;
			case 3:
				((n = u), (e = c), (r = h));
				break;
			case 4:
				((n = s), (e = u), (r = h));
				break;
			case 5:
				((n = h), (e = u), (r = c));
		}
		return [a(255 * n), a(255 * e), a(255 * r)];
	}
	function l(t) {
		return p(f(t));
	}
	function h(t) {
		var n,
			e = +t[0],
			r = +t[1],
			o = +t[2],
			i = Math.max(e, r, o),
			u = Math.min(e, r, o),
			c = i - u,
			s = 0 === i ? 0 : c / i,
			a = i / 255;
		switch (i) {
			case u:
				n = 0;
				break;
			case e:
				((n = r - o + c * (o > r ? 6 : 0)), (n /= 6 * c));
				break;
			case r:
				((n = o - e + 2 * c), (n /= 6 * c));
				break;
			case o:
				((n = e - r + 4 * c), (n /= 6 * c));
		}
		return [n, s, a];
	}
	function p(t) {
		var n = +t[2] | (+t[1] << 8) | (+t[0] << 16);
		return ((n = '000000' + n.toString(16)), n.slice(-6));
	}
	function v(t) {
		return h(d(t));
	}
	function d(t) {
		return (
			3 === t.length && (t = t.replace(/./g, '$&$&')), [s(t[0] + t[1], 16), s(t[2] + t[3], 16), s(t[4] + t[5], 16)]
		);
	}
	function g(t) {
		return [+t[0] / 360, +t[1] / 100, +t[2] / 100];
	}
	function y(t) {
		return [a(360 * +t[0]), a(100 * +t[1]), a(100 * +t[2])];
	}
	function x(t) {
		return [+t[0] / 255, +t[1] / 255, +t[2] / 255];
	}
	function m(t) {
		if (i(t)) return t;
		var n = /\s*rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)\s*$/i.exec(t),
			e = /\s*hsv\s*\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*\)\s*$/i.exec(t),
			r = '#' === t[0] && t.match(/^#([\da-f]{3}|[\da-f]{6})$/i);
		return r ? v(t.slice(1)) : e ? g([+e[1], +e[2], +e[3]]) : n ? h([+n[1], +n[2], +n[3]]) : [0, 1, 1];
	}
	var b = '__instance__',
		H = 'firstChild',
		k = 'scrollLeft',
		w = 'scrollTop',
		E = 'offsetLeft',
		X = 'offsetTop',
		S = setTimeout;
	!(function (t) {
		((t.version = '1.3.5'),
			(t[b] = {}),
			(t.each = function (n, e) {
				return (
					S(
						function () {
							var e,
								r = t[b];
							for (e in r) n(r[e], e, r);
						},
						0 === e ? 0 : e || 1,
					),
					t
				);
			}),
			(t.parse = m),
			(t._HSV2RGB = f),
			(t._HSV2HEX = l),
			(t._RGB2HSV = h),
			(t._HEX2HSV = v),
			(t._HEX2RGB = function (t) {
				return x(d(t));
			}),
			(t.HSV2RGB = function (t) {
				return f(g(t));
			}),
			(t.HSV2HEX = function (t) {
				return l(g(t));
			}),
			(t.RGB2HSV = function (t) {
				return y(h(t));
			}),
			(t.RGB2HEX = p),
			(t.HEX2HSV = function (t) {
				return y(v(t));
			}),
			(t.HEX2RGB = d));
	})(
		(t[e] = function (s, a) {
			function h(t, n, e) {
				t = t.split(/\s+/);
				for (var r = 0, o = t.length; o > r; ++r) n.addEventListener(t[r], e, !1);
			}
			function p(t, n, e) {
				t = t.split(/\s+/);
				for (var r = 0, o = t.length; o > r; ++r) n.removeEventListener(t[r], e);
			}
			function v(t, n) {
				var e = n.touches ? n.touches[0].pageX : n.pageX,
					r = n.touches ? n.touches[0].pageY : n.pageY,
					o = d(t);
				return { x: e - o.l, y: r - o.t };
			}
			function d(n) {
				if (n === t)
					var e = t.pageXOffset || T[k],
						r = t.pageYOffset || T[w];
				else for (var e = n[E], r = n[X]; (n = n.offsetParent); ) ((e += n[E]), (r += n[X]));
				return { l: e, t: r };
			}
			function g(t, n) {
				for (; (t = t.parentElement) && t !== n; );
				return t;
			}
			function y(t) {
				t && t.preventDefault();
			}
			function x(n) {
				return n === t ? { w: t.innerWidth, h: t.innerHeight } : { w: n.offsetWidth, h: n.offsetHeight };
			}
			function m(t) {
				return Y || (r(t) ? t : !1);
			}
			function _(t) {
				Y = t;
			}
			function V(t, n, e) {
				return r(t) ? (r(n) ? (r(N[t]) || (N[t] = {}), r(e) || (e = u(N[t])), (N[t][e] = n), j) : N[t]) : N;
			}
			function B(t, n) {
				return r(t) ? (r(n) ? (delete N[t][n], j) : ((N[t] = {}), j)) : ((N = {}), j);
			}
			function G(t, n, e) {
				if (!r(N[t])) return j;
				if (r(e)) r(N[t][e]) && N[t][e].apply(j, n);
				else for (var o in N[t]) N[t][o].apply(j, n);
				return j;
			}
			function R(t, n) {
				((t && 'h' !== t) || G('change:h', n), (t && 'sv' !== t) || G('change:sv', n), G('change', n));
			}
			function M() {
				return W.parentNode;
			}
			function L(e, r) {
				function o(t) {
					var n = t.target,
						e = n === s || g(n, s) === s;
					(e ? L() : j.exit(), G(e ? 'enter' : 'exit', [j]));
				}
				function i(t) {
					var n = (f(F), f([F[0], 1, 1]));
					((K.style.backgroundColor = 'rgb(' + n.join(',') + ')'), _(F), y(t));
				}
				function u(t) {
					var n = c(v(J, t).y, 0, S);
					((F[0] = (S - n) / S), (Q.style.top = n - T / 2 + 'px'), i(t));
				}
				function d(t) {
					var n = v(K, t),
						e = c(n.x, 0, V),
						r = c(n.y, 0, B);
					((F[1] = 1 - (V - e) / V),
						(F[2] = (B - r) / B),
						(U.style.right = V - e - O / 2 + 'px'),
						(U.style.top = r - Y / 2 + 'px'),
						i(t));
				}
				function b(t) {
					(nn && (u(t), (sn = l(F)), Z || (G('drag:h', [sn, j]), G('drag', [sn, j]), R('h', [sn, j]))),
						en && (d(t), (sn = l(F)), tn || (G('drag:sv', [sn, j]), G('drag', [sn, j]), R('sv', [sn, j]))),
						(Z = 0),
						(tn = 0));
				}
				function H(t) {
					var n = t.target,
						e = nn ? 'h' : 'sv',
						r = [l(F), j],
						o = n === s || g(n, s) === s,
						i = n === W || g(n, W) === W;
					(o || i
						? i && (G('stop:' + e, r), G('stop', r), R(e, r))
						: M() && a !== !1 && (j.exit(), G('exit', [j]), R(0, r)),
						(nn = 0),
						(en = 0));
				}
				function k(t) {
					((Z = 1), (nn = 1), b(t), y(t), G('start:h', [sn, j]), G('start', [sn, j]), R('h', [sn, j]));
				}
				function w(t) {
					((tn = 1), (en = 1), b(t), y(t), G('start:sv', [sn, j]), G('start', [sn, j]), R('sv', [sn, j]));
				}
				(e || ((r || C).appendChild(W), (j.visible = !0)), (un = x(W).w), (cn = x(W).h));
				var E = x(K),
					X = x(U),
					S = x(J).h,
					V = E.w,
					B = E.h,
					T = x(Q).h,
					O = X.w,
					Y = X.h;
				(e
					? ((W.style.left = W.style.top = '-9999px'),
						a !== !1 && h(a, s, o),
						(j.create = function () {
							return (L(1), G('create', [j]), j);
						}),
						(j.destroy = function () {
							return (a !== !1 && p(a, s, o), j.exit(), _(!1), G('destroy', [j]), j);
						}))
					: $(),
					(I = function () {
						((F = m(F)),
							i(),
							(Q.style.top = S - T / 2 - S * +F[0] + 'px'),
							(U.style.right = V - O / 2 - V * +F[1] + 'px'),
							(U.style.top = B - Y / 2 - B * +F[2] + 'px'));
					}),
					(j.exit = function () {
						return (
							M() && (M().removeChild(W), (j.visible = !1)),
							p(P, J, k),
							p(P, K, w),
							p(z, n, b),
							p(A, n, H),
							p(D, t, $),
							j
						);
					}),
					I(),
					e || (h(P, J, k), h(P, K, w), h(z, n, b), h(A, n, H), h(D, t, $)));
			}
			function $() {
				return j.fit();
			}
			var C = n.body,
				T = n.documentElement,
				j = this,
				O = t[e],
				Y = !1,
				N = {},
				W = n.createElement('div'),
				P = 'touchstart mousedown',
				z = 'touchmove mousemove',
				A = 'touchend mouseup',
				D = 'orientationchange resize';
			if (!(j instanceof O)) return new O(s, a);
			((O[b][s.id || s.name || u(O[b])] = j),
				r(a) || (a = P),
				_(O.parse(s.getAttribute('data-color') || s.value || [0, 1, 1])),
				(W.className = 'color-picker'),
				(W.innerHTML =
					'<div class="color-picker-control"><span class="color-picker-h"><i></i></span><span class="color-picker-sv"><i></i></span></div>'));
			var I,
				q = W[H].children,
				F = m([0, 1, 1]),
				J = q[0],
				K = q[1],
				Q = J[H],
				U = K[H],
				Z = 0,
				tn = 0,
				nn = 0,
				en = 0,
				rn = 0,
				on = 0,
				un = 0,
				cn = 0,
				sn = l(F);
			return (
				L(1),
				S(function () {
					var t = [l(F), j];
					(G('create', t), R(0, t));
				}, 0),
				(j.fit = function (n) {
					var e = x(t),
						o = x(T),
						u = o.h > e.h,
						c = d(t),
						a = (d(T), u ? o.w : e.w + c.l),
						f = u ? e.h + c.t : Math.max(o.h, e.h),
						l = d(s);
					return (
						(rn = l.l),
						(on = l.t + x(s).h),
						i(n)
							? (r(n[0]) && (rn = n[0]), r(n[1]) && (on = n[1]))
							: (rn + un > a && (rn = a - un), on + cn > f && (on = f - cn)),
						(W.style.left = rn + 'px'),
						(W.style.top = on + 'px'),
						G('fit', [j]),
						j
					);
				}),
				(j.set = function (t) {
					return r(t) ? (o(t) && (t = O.parse(t)), _(t), I(), j) : m();
				}),
				(j.get = function (t) {
					return m(t);
				}),
				(j.target = s),
				(j.picker = W),
				(j.visible = !1),
				(j.on = V),
				(j.off = B),
				(j.trigger = G),
				(j.hooks = N),
				(j.enter = function (t) {
					return L(0, t);
				}),
				j
			);
		}),
	);
})(window, document, 'CP');
